import { gql } from "@apollo/client";

export const ADD_COMPANY_SUBSCRIPTION = gql(/* GraphQL */ `
  mutation AddCompanySubscription($input: AddCompanySubscriptionInput!) {
    addCompanySubscription(
      input: $input
    ) {
      __typename
      companySubscription {
        id
      }
      errors {
        ... on ValidationError {
          message
          errors {
            fieldName
            messages
          }
        }
      }
    }
  }
`);
